export default {
  //购物车操作api
  cart_operationApi: 'client/basket/item/skipAuth/operation',
  //购物车列表操作
  cart_operationListApi: 'client/basket/item/skipAuth/list/operation',
  //获取商购物车商品
  cart_getProductList: 'client/basket/skipAuth/retrieve',
  //结算购物车
  cart_settlement: 'client/basket/settlement',
  //获取结算商品
  cart_getProductSettlementList: 'client/basket/settlementList',
}